import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {inject, observer} from "mobx-react";
import cx from 'classnames';

import MyFavoriteTournaments from './my-favorite-tournament';
import MyFavoriteTeams from './my-favorite-teams';
import {trans} from '../../../../common/utils';
import MyFavoritesMatchesList from './my-favorites-match-list';
import { LLPreloader } from '../../../../components';


const MyFavoritesList = ({store}) => {
    const
        [tab, setTab] = useState('tournaments'),
        [view, setView] = useState('default');

    const
        viewSize = store.site.status.viewSize,
        isLogged = store.user.isLogged;

    useEffect(() => {
        if (isLogged) {}
    }, [isLogged])

    useEffect(() => {
        if (viewSize === 'mobile') {
            setView('default');
        }
    }, [tab]);

    return (
        <div className="my-favorites">
            <div className="my-favorites__header">
                <span>
                    <i className="my-favorites__header-icon doruk-star-fill" />
                    <span>{trans('My Favorites')}</span>
                </span>
                {viewSize === 'mobile' ? (
                    <Link to="/sport">
                        <i className="my-favorites__header-icon my-favorites__header-icon--close doruk-close"></i>
                    </Link>
                ) : null}
            </div>
            {viewSize === 'mobile' ? (
                <div className="my-favorites__tabs">
                    <div className={cx('my-favotites__tab', tab === 'tournaments' && 'my-favotites__tab--active')} onClick={() => setTab('tournaments')}>
                        <span>{trans('Tournaments')}</span>
                        <span>({store.betting.favorites.tournaments?.length ?? 0}/50)</span>
                    </div>
                    <div className={cx('my-favotites__tab', tab === 'teams' && 'my-favotites__tab--active')} onClick={() => setTab('teams')}>
                        <span>{trans('Teams')}</span>
                        <span>({store.betting.favorites.teams?.length ?? 0}/50)</span>
                    </div>
                </div>
            ) : null}
            <div className={cx('my-favorites__content', view === 'matches' && 'my-favorites__content--auto-height')}>
                {tab === 'tournaments' || viewSize !== 'mobile' ? (
                    <div className="my-favorites__column">
                        <MyFavoriteTournaments view={view} setView={setView} tab={tab} setTab={setTab} />
                    </div>
                ) : null}
                {tab === 'teams' || viewSize !== 'mobile' ? (
                    <div className="my-favorites__column">
                        <MyFavoriteTeams view={view} setView={setView} tab={tab} setTab={setTab} />
                    </div>
                ) : null}
            </div>
            {view === 'matches' ? (
                <div className="my-favorite__matches-list">
                    {store.betting.favorites[`${tab}Loading`] ? (
                        <div className="my-favorite__column-content-laoding">
                            <LLPreloader height={50} width={50} />
                        </div>
                    ) : (
                        <MyFavoritesMatchesList type={tab} />
                    )}
                </div>
            ) : null}
        </div>
    );
};

export default inject('store')(observer(MyFavoritesList));
